var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',_vm._l((_vm.champs),function(rowitem,rowindex){return _c('Routing',{key:rowindex,attrs:{"item":rowitem,"event":_vm.event}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }